module.exports = __webpack_public_path__ + "img/DISPTCHD.ccd2818e.svg";